import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/dcm-2020/dcm-2020.github.io/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`We welcome original research papers no longer than 5 pages in total: 4 pages for the body of the paper (including all figures), plus up to one additional page with references that do not fit within the six body pages.`}</p>
      <p>{`Papers must be formatted according to the `}<a parentName="p" {...{
          "href": "https://www.ijcai.org/authors_kit"
        }}>{`IJCAI guidelines`}</a>{`. Submissions should be in .pdf format.`}</p>
      <p>{`Submission Website: `}<a parentName="p" {...{
          "href": "https://cmt3.research.microsoft.com/DCM2020"
        }}>{`CMT`}</a></p>
    </PageDescription>
    <h2>{`Important Dates (updated due to COVID-19)`}</h2>
    <p>{`Submission deadline: Sunday, 13 September 2020 (23:59 Pacific Time)`}</p>
    <p>{`Author notification: Sunday, 4 October 2020 (23:59 Pacific Time)`}</p>
    <p>{`Camera ready deadline: Sunday, 25 October 2020 (23:59 Pacific Time)`}</p>
    <p>{`IJCAI-PRICAI has been postponed to January 2021 due to the COVID-19 pandemic. Please find updated information about new dates and location in the conference website (`}<a parentName="p" {...{
        "href": "https://ijcai20.org/"
      }}>{`https://ijcai20.org/`}</a>{`, Covid Update on May 7th, 2020).`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      